import DIRECTION_OFFSETS from '_data/puzzleDirections';
import { isCellCompatible } from '_utils';

export function canInsertHorizontal(engine, word, row, col, table) {
  if (col + word.length > engine.model.columns) return false;

  for (let i = 0; i < word.length; i += 1) {
    const idx = row * engine.model.columns + (col + i);
    if (!isCellCompatible(idx, word[i], table)) return false;
  }
  return true;
}

export function canInsertVertical(engine, word, row, col, table) {
  if (row + word.length > engine.model.rows) return false;

  for (let i = 0; i < word.length; i += 1) {
    const idx = (row + i) * engine.model.columns + col;
    if (!isCellCompatible(idx, word[i], table)) return false;
  }
  return true;
}

export function canInsertDiagonal(engine, word, row, col, direction, table) {
  const offset = DIRECTION_OFFSETS[direction];

  const endRow = row + offset.row * (word.length - 1);
  const endCol = col + offset.col * (word.length - 1);

  if (endRow < 0 || endRow >= engine.model.rows) return false;
  if (endCol < 0 || endCol >= engine.model.columns) return false;

  for (let i = 0; i < word.length; i += 1) {
    const r = row + offset.row * i;
    const c = col + offset.col * i;
    const idx = r * engine.model.columns + c;

    if (!isCellCompatible(idx, word[i], table)) return false;
  }

  return true;
}
